import { createRootStore } from './store';
import { RootStore } from './types';

let store: RootStore | undefined;

export const initializeStore = () => {
  if (store) {
    return store;
  }

  store = createRootStore();

  return store;
};
